export default "__VITE_ASSET__BAtCKmJY__"